import { render, staticRenderFns } from "./ClientTests.vue?vue&type=template&id=d84ded7c&scoped=true&"
import script from "./ClientTests.vue?vue&type=script&lang=js&"
export * from "./ClientTests.vue?vue&type=script&lang=js&"
import style0 from "./ClientTests.vue?vue&type=style&index=0&id=d84ded7c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d84ded7c",
  null
  
)

export default component.exports